import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {FlightsDatesSelector} from "../../../services/flight-search/dates-selection/flights-dates-selector";
import {IDropDownController} from "../../drop-down/drop-down-controller.interface";
import {FlightDatesDropdownHeaderInOpenStateComponent} from "./open-state/flight-dates-dropdown-header-in-open-state.component";
import {FlightDatesDropdownHeaderInClosedStateComponent} from "./closed-state/flight-dates-dropdown-header-in-closed-state.component";

const HeaderContainerBox = styled.div`
    display: flex;
    width: 100%;
`

interface FlightDatesDropdownPcHeaderComponentProps {
    datesSelector: FlightsDatesSelector;
    dropDownController: IDropDownController;
}

export const FlightDatesDropdownPcHeaderComponent: React.FC<FlightDatesDropdownPcHeaderComponentProps> = observer((props) => {

    const renderContent = () => {
        if(props.dropDownController.isOpen() && (props.datesSelector.searchController.departureDate)) {
            return (
                <FlightDatesDropdownHeaderInOpenStateComponent datesSelector={props.datesSelector}/>
            );
        } else {
            return (
                <FlightDatesDropdownHeaderInClosedStateComponent datesSelector={props.datesSelector}/>
            );
        }
    }

    return (
        <HeaderContainerBox>
            {renderContent()}
        </HeaderContainerBox>
    )

});
